module.exports = __webpack_public_path__ + "static/media/home_select.7262146f.svg";